import { createFileRoute } from "@tanstack/react-router";
import { CityPageBody } from "@/components/site/CityPageBody";
import { BUSINESS } from "@/components/site/constants";
import { canonical } from "@/components/site/site-config";

export const Route = createFileRoute("/roofing-company-floral-city-fl")({
  head: () => ({
    meta: [
      { title: "Roofing Company in Floral City, FL | Destination Roofing" },
      { name: "description", content: `Local roofing company serving Floral City, FL. Roof repair, replacement, metal roofing and storm-damage roofing. Free Roof Inspection & Estimate. Call ${BUSINESS.phone}.` },
      { property: "og:title", content: "Roofing Company in Floral City, FL" },
      { property: "og:description", content: "Family-owned roofer serving Floral City, FL." },
      { property: "og:url", content: canonical("/roofing-company-floral-city-fl") },
    ],
    links: [{ rel: "canonical", href: canonical("/roofing-company-floral-city-fl") }],
  }),
  component: () => (
    <CityPageBody
      city="Floral City"
      intro={
        <p>
          Floral City is one of the older communities in Citrus County — a mix of historic homes, lakefront properties, and rural acreage. Roofs here see everything from towering oak canopy overhead to full open sun over pastureland, which changes what a roof needs to hold up for the long haul.
        </p>
      }
      localNotes={
        <>
          <p>
            On the historic homes near the moss-draped oaks, we frequently see moisture damage, moss growth on shaded slopes, and older shingle systems near the end of their life. On the more open properties, we see UV-baked shingles and heat-related granule loss.
          </p>
          <p>
            Metal roofing is a strong option in Floral City for homeowners who want a long-term solution that stands up to both moss and Florida sun without frequent maintenance.
          </p>
        </>
      }
    />
  ),
});
